// Enums
import { TechnologyActionTypeEnum } from "Enums";
// Interfaces
import { ISetTechnologyCountsAction, ITechnologyAction } from "Interfaces";
// Types
import { TTechnologyState } from "Types";

export const TechnologyReducer = (state: TTechnologyState, action: ITechnologyAction): TTechnologyState => {
    // First, we figure out what action
    // has been fired:
    switch (action.type) {
        // Then, for each action
        // we describe an according state update.
        case TechnologyActionTypeEnum.SetTechnologyCounts:
            const setTechnologyCountAction = action as ISetTechnologyCountsAction;

            return {
                ...state,
                counts: setTechnologyCountAction.counts                
            };
        // If the action is unknown
        // we return the current state:
        default:
            return state;
    }
};
